export const FOCUS_RING =
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--color-surface)]';

export const INPUT_BASE =
  `w-full px-3 py-2 border border-[var(--color-border)] rounded-lg ` +
  `bg-[var(--color-background)] text-white placeholder-gray-500 transition-colors ${FOCUS_RING} ` +
  'disabled:cursor-not-allowed disabled:opacity-60 disabled:bg-[var(--color-surface-hover)]';

export const INPUT_ERROR = INPUT_BASE
  .replace('border-[var(--color-border)]', 'border-red-500/50')
  .replace('focus-visible:ring-blue-500', 'focus-visible:ring-red-500 focus:ring-red-500');

export const SUBMIT_BUTTON =
  `inline-flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white rounded-lg ` +
  `text-sm font-medium shadow-sm shadow-blue-600/20 transition-colors ${FOCUS_RING} ` +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export const CANCEL_BUTTON =
  `inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg border border-[var(--color-border)] ` +
  `bg-[var(--color-background)] text-[var(--color-text-muted)] hover:bg-[var(--color-surface-hover)] hover:text-white transition-colors ${FOCUS_RING} ` +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export const DANGER_BUTTON =
  `inline-flex items-center justify-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 active:bg-red-800 text-white rounded-lg ` +
  `text-sm font-medium transition-colors ${FOCUS_RING} disabled:opacity-50 disabled:cursor-not-allowed`;

export const OUTLINE_BUTTON =
  `inline-flex items-center justify-center gap-2 px-3 py-2 text-sm font-medium rounded-lg border border-[var(--color-border)] ` +
  `bg-[var(--color-background)] text-[var(--color-text-muted)] hover:bg-[var(--color-surface-hover)] hover:text-white transition-colors ${FOCUS_RING} ` +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export const ICON_BUTTON =
  `inline-flex items-center justify-center p-2 rounded-lg text-[var(--color-text-muted)] hover:text-white hover:bg-[var(--color-surface-hover)] transition-colors ${FOCUS_RING} ` +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export const ICON_BUTTON_DANGER =
  `inline-flex items-center justify-center p-2 rounded-lg text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-colors ${FOCUS_RING} ` +
  'disabled:opacity-50 disabled:cursor-not-allowed';

export const COMPACT_INPUT =
  `block w-full px-2 py-1 text-xs border border-[var(--color-border)] rounded-md bg-[var(--color-background)] text-white placeholder-gray-500 transition-colors ${FOCUS_RING} ` +
  'disabled:opacity-60 disabled:cursor-not-allowed';

export const CHECKBOX =
  `h-4 w-4 rounded border-[var(--color-border)] bg-[var(--color-background)] text-blue-500 ${FOCUS_RING} disabled:opacity-50 disabled:cursor-not-allowed`;

export const PANEL =
  'bg-[var(--color-surface)] border border-[var(--color-border)] rounded-xl';

export const INSET_PANEL =
  'border border-[var(--color-border)] rounded-lg bg-[var(--color-background)]';

export const SEGMENTED_CONTROL =
  'inline-flex items-center overflow-hidden rounded-lg border border-[var(--color-border)] bg-[var(--color-background)]';

export const SEGMENTED_OPTION =
  `px-3 py-1.5 text-sm font-medium text-[var(--color-text-muted)] hover:bg-[var(--color-surface-hover)] hover:text-white transition-colors ${FOCUS_RING}`;

export const SEGMENTED_OPTION_ACTIVE =
  'bg-blue-600 text-white hover:bg-blue-600 hover:text-white';

export const POPOVER =
  'bg-[var(--color-surface)] border border-[var(--color-border)] rounded-lg shadow-xl';

export const POPOVER_OPTION =
  `w-full flex items-center text-left hover:bg-[var(--color-surface-hover)] transition-colors ${FOCUS_RING}`;

export const BADGE =
  'inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset';

export const LABEL_CLASS =
  'block text-sm font-medium text-[var(--color-text-muted)] mb-1';

export const SECTION_LABEL =
  'text-[11px] font-semibold uppercase tracking-wider ' +
  'text-[var(--color-text-muted)] mb-1';
